<template>

</template>

<script>
export default {
  name: "PageRegister"
}
</script>

<style scoped>

</style>
